
import React from "react";
import "../styles/ElementalStyles.css";
import { usePageInitialization } from "../hooks/usePageInitialization";

// Import the individual section components
import Header from "../components/sections/Header";
import KitConsultingAbout from "../components/sections/KitConsultingAbout";
import Footer from "../components/sections/Footer";
import Subvencio from "../components/sections/Subvencio";
import HeadMeta from "../components/sections/HeadMeta";
import PerformanceMonitor from "../components/performance/PerformanceMonitor";

const KitConsultingPage = () => {
  // Use our new centralized initialization hook
  usePageInitialization("Kit Consulting - Elemental Value", {
    handleSplash: false,
    initSwiper: false // We're using our new carousel
  });

  return (
    <>
      <HeadMeta
        title="Kit Consulting — Consultoría financiera subvencionada | Elemental Value"
        description="Programa Kit Consulting de Red.es: consultoría financiera para pymes con ayudas de hasta 24.000€. Diagnóstico, reporting y dirección financiera."
        canonicalPath="/kit-consulting"
      />
      <Header />
      <div className="pt-24 w-full max-w-none">
        <h1 className="text-4xl font-bold mb-8 text-center">Kit Consulting</h1>
        <KitConsultingAbout />
        <Footer />
        <Subvencio />
      </div>
      <PerformanceMonitor />
    </>
  );
};

export default KitConsultingPage;
